module.exports = __webpack_public_path__ + "static/illustration2-1944bc40177e05486865585c9427b67e.png";